var React = require('react');

function GEOMobile (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.3703 0.53125C6.30332 0.53125 0.570312 5.85525 0.570312 12.4162C0.570312 21.6602 13.3703 37.5092 13.3703 37.5092C13.3703 37.5092 26.1703 21.6602 26.1703 12.4162C26.1703 5.85525 20.4373 0.53125 13.3703 0.53125ZM13.3703 17.5003C12.5458 17.5003 11.7397 17.2557 11.0541 16.7976C10.3685 16.3396 9.8342 15.6884 9.51866 14.9267C9.20312 14.1649 9.12056 13.3266 9.28142 12.5179C9.44228 11.7092 9.83934 10.9664 10.4224 10.3833C11.0054 9.80028 11.7483 9.40322 12.557 9.24236C13.3657 9.08149 14.2039 9.16405 14.9657 9.4796C15.7275 9.79514 16.3786 10.3295 16.8367 11.0151C17.2948 11.7007 17.5393 12.5067 17.5393 13.3312C17.5393 14.4369 17.1001 15.4973 16.3182 16.2792C15.5364 17.061 14.476 17.5003 13.3703 17.5003Z","fill":"#2CD0DB"}));
}

GEOMobile.defaultProps = {"width":"27","height":"38","viewBox":"0 0 27 38","fill":"none"};

module.exports = GEOMobile;

GEOMobile.default = GEOMobile;
